var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{staticStyle:{"overflow-x":"hidden"}},[_c('pcc-table')],1)],1),_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"title":"Request Product PCC"}},[_c('rating-pcc-table')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }